import { CellContext, ColumnDef } from '@tanstack/react-table';
import React from 'react';
import { Badge } from '../../../../../../../components/Common/UI/Badge';
import { JobDetailsRow } from './jobDetailsData';
import { useJobDetailsProvider } from '../../../../../../context/jobDetails';
import { cn } from '../../../../../../../utils/styles';
import { JobDetailColumnType } from '../subTableConfig';

function CounterBadgeAction({ row, column }: CellContext<JobDetailsRow, unknown>) {
  const { handleSelectedTable, selectedTable } = useJobDetailsProvider();
  const { getValue, original } = row;

  const handleClick = () => {
    handleSelectedTable({ row: original.type, column: column.id as JobDetailColumnType });
  };

  const activeRows = ['ACCOUNTS', 'INSERTS'];
  /** Button is active only if row - Accounts and value not 0. */
  // original.type !== 'ACCOUNTS'
  const isDisabled = !activeRows.includes(original.type) || getValue(column.id) === 0;
  const isActiveStyle = selectedTable.row === original.type && selectedTable.column === column.id;

  return (
    <Badge
      variant={!isDisabled ? 'counter' : 'counterDisabled'}
      onClick={!isDisabled ? handleClick : undefined}
      className={cn('cursor-pointer hover:bg-addition4-10', {
        'bg-addition4-20 hover:bg-addition4-20': isActiveStyle && !isDisabled,
      })}
    >
      {getValue(column.id)}
    </Badge>
  );
}

export const jobDetailColElectronic: ColumnDef<JobDetailsRow>[] = [
  {
    accessorKey: 'type',
    header: 'Type',
    cell: ({ row }) => <span className="text-xs font-medium tracking-widest">{row.getValue('type')}:</span>,
  },
  {
    accessorKey: 'total',
    header: 'Total',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'posted',
    header: 'Posted',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'failed',
    header: 'Failed',
    cell: CounterBadgeAction,
    size: 100,
  },
];

export const jobDetailColPaper: ColumnDef<JobDetailsRow>[] = [
  {
    accessorKey: 'type',
    header: 'Type',
    cell: ({ row }) => <span className="text-xs font-medium tracking-widest">{row.getValue('type')}:</span>,
  },
  {
    accessorKey: 'total',
    header: 'Total',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'presort',
    header: 'Presort',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'firstClass',
    header: 'First Class',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'nonMail',
    header: 'Non-mail',
    cell: CounterBadgeAction,
  },
  {
    accessorKey: 'nonPrint',
    header: 'Non-print',
    cell: CounterBadgeAction,
  },
];
